module.exports = { "default": require("core-js/library/fn/math/clz32"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/clz32.js
// module id = 1039
// module chunks = 61